// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"48":"745620e058471185","163":"6f26f57f45d21c9e","204":"e3a90a9961691c26","324":"ee0d818db5e99f98","394":"3b4dd93a59016a8c","453":"5d780324daf21333","851":"741e1a3fbcf3cc01","856":"ea1378a7759d6d4c","997":"1c78817b97070af8"}[chunkId] + ".js";
};